import cn from 'classnames';
import { ComponentProps } from 'react';
import { Card } from '@shared/ui/index.ts';
import st from './styles.module.scss';

export const GridSkeleton = () => {
  return (
    <Card className={st.card}>
      <div className={st.card__image} />
      <div className={st.card__first_text_block} />
      <div className={st.card__last_text_block} />
    </Card>
  );
};

const array = new Array(8);

export const SkeletonGridList = ({ className, ...rest }: ComponentProps<'div'>) => {
  return (
    <div className={cn(st.skeletonList, className)} {...rest}>
      {[...array].map((_, index) => (
        <GridSkeleton key={index} />
      ))}
    </div>
  );
};
